module.exports = __webpack_public_path__ + "static/img/prize02.e3fa6c29.gif";